import React from "react"
import styled from "styled-components"
import { devices } from "Utils/devices"

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 75px;
`
const SVG = styled.svg`
  fill: #787878;
  ${({ isFromWidgetChoice }) =>
    isFromWidgetChoice &&
    `
    @media ${devices.tablet} {
      width: 40px; 
      height: 40px;
    }`}
`

const ChartHeatMapIcon = ({ isFromWidgetChoice }) => (
  <IconContainer>
    <SVG
      width="65"
      height="65"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      isFromWidgetChoice={isFromWidgetChoice}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="invisible_box" data-name="invisible box">
          <rect width="48" height="48" fill="none" />
        </g>
        <g id="Q3_icons" data-name="Q3 icons">
          <path
            className="fillHoverSVG"
            d="M44,42a2,2,0,0,1-2,2H4V6A2,2,0,0,1,8,6V40H42A2,2,0,0,1,44,42ZM12,30a.9.9,0,0,0-1,1v4a.9.9,0,0,0,1,1h4a.9.9,0,0,0,1-1V31a.9.9,0,0,0-1-1Zm-1-4h6a.9.9,0,0,0,1-1V19a.9.9,0,0,0-1-1H11a.9.9,0,0,0-1,1v6A.9.9,0,0,0,11,26Zm24,0h6a.9.9,0,0,0,1-1V19a.9.9,0,0,0-1-1H35a.9.9,0,0,0-1,1v6A.9.9,0,0,0,35,26ZM23,15h6a.9.9,0,0,0,1-1V8a.9.9,0,0,0-1-1H23a.9.9,0,0,0-1,1v6A.9.9,0,0,0,23,15ZM22,38h8a.9.9,0,0,0,1-1V29a.9.9,0,0,0-1-1H22a.9.9,0,0,0-1,1v8A.9.9,0,0,0,22,38Zm2-19a.9.9,0,0,0-1,1v4a.9.9,0,0,0,1,1h4a.9.9,0,0,0,1-1V20a.9.9,0,0,0-1-1ZM37,31a.9.9,0,0,0-1,1v2a.9.9,0,0,0,1,1h2a.9.9,0,0,0,1-1V32a.9.9,0,0,0-1-1Zm0-18h2a.9.9,0,0,0,1-1V10a.9.9,0,0,0-1-1H37a.9.9,0,0,0-1,1v2A.9.9,0,0,0,37,13ZM13,13h2a.9.9,0,0,0,1-1V10a.9.9,0,0,0-1-1H13a.9.9,0,0,0-1,1v2A.9.9,0,0,0,13,13Z"
          />
        </g>
      </g>
    </SVG>
  </IconContainer>
)

export default ChartHeatMapIcon
